import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from 'src/utils';
import history from 'src/utils/history';
import store from 'src/store';

export const getCustomMetrics = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch(getCustomMetricsRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/custom-metrics',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getCustomMetricsSuccess(transformCustomMetrics(res.data)));
      })
      .catch(err => {
        dispatch(getCustomMetricsFailure(err));
      });
  };
};

export const deleteCustomMetric = (entityId, id) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/custom-metrics/' + id,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getCustomMetrics(entityId, sessionId));
      })
      .catch(err => {
        dispatch(deleteCustomMetricFailure(err));
      });
  };
};

export const saveCustomMetric = customMetric => {
  const sessionId = getSessionId();
  return dispatch => {
    dispatch(saveCustomMetricsRequest());
    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/custom-metrics/',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: customMetric
    })
      .then(res => {
        dispatch(saveCustomMetricSuccess(res.data));
        dispatch(getCustomMetrics(customMetric.entityId, sessionId));
        history.push('/custom-metrics');
      })
      .catch(err => {
        dispatch(saveCustomMetricFailure(err));
      });
  };
};

export const labelCustomMetric = (entityId, customMetric) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url:
        '/openempi-ws-rest/1.0/custom-metrics/' + customMetric.customMetricId,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      },
      data: customMetric
    })
      .then(res => {
        dispatch(labelCustomMetricSuccess(res.data));
      })
      .catch(err => {
        dispatch(labelCustomMetricFailure(err));
      });
  };
};

export const clearCustomMetricsError = () => {
  return {
    type: Constants.CUSTOMMETRICS_CLEAR_ERROR
  };
};

const getCustomMetricsRequest = () => {
  return {
    type: Constants.CUSTOMMETRICS_GET_REQUEST
  };
};

const saveCustomMetricsRequest = () => {
  return {
    type: Constants.CUSTOMMETRICS_SAVE_REQUEST
  };
};

const getCustomMetricsSuccess = data => {
  return {
    type: Constants.CUSTOMMETRICS_GET_SUCCESS,
    payload: data
  };
};

const getCustomMetricsFailure = err => {
  if (err && err.response && err.response.status === 404) {
    return {
      type: Constants.CUSTOMMETRICS_NOT_FOUND
    };
  }
  const payload = getPayloadFromError(err);
  return {
    type: Constants.CUSTOMMETRICS_GET_FAILURE,
    payload
  };
};

const deleteCustomMetricFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.CUSTOMMETRICS_DELETE_FAILURE,
    payload
  };
};

const saveCustomMetricFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.CUSTOMMETRICS_SAVE_FAILURE,
    payload
  };
};

const saveCustomMetricSuccess = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.CUSTOMMETRICS_SAVE_SUCCESS,
    payload
  };
};

const labelCustomMetricSuccess = data => {
  return {
    type: Constants.CUSTOMMETRICS_LABEL_SUCCESS,
    payload: data
  };
};

const labelCustomMetricFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.CUSTOMMETRICS_LABEL_FAILURE,
    payload
  };
};

const transformCustomMetrics = entries => {
  const users = store.getState().users.users;
  const output = entries.map(entry => {
    const user = users.find(user => user.id === entry.userCreatedById);
    if (user) {
      entry['userCreatedBy'] = user.username;
    }
    return entry;
  });
  return output;
};
